import React, { useCallback, useEffect, useState } from 'react'

export const Countdown = () => {
  const endDate = 'Dec 3, 2024 07:59:59 CST'
  const deadline = new Date(endDate).getTime()

  const [timeLeft, setTimeLeft] = useState(0)
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  const updateValues = useCallback(() => {
    const now = new Date().getTime()
    const delta = deadline - now
    setTimeLeft(delta)

    const days = Math.floor(delta / (1000 * 60 * 60 * 24))
    const hoursOnly = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

    setDays(days)
    setHours(hoursOnly)
    setMinutes(Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60)))
    setSeconds(Math.floor((delta % (1000 * 60)) / 1000))
  }, [deadline])

  useEffect(() => {
    updateValues()

    const interval = setInterval(() => {
      updateValues()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [updateValues])

  if (timeLeft <= 0) {
    return null
  }

  return (
    <div>
      <div id="countdown">
        <div className="countdown-block">
          <div className="countdown-value" id="hour">
            {days}
          </div>
          <div className="countdown-label">Days</div>
        </div>
        <div className="countdown-block">
          <div className="countdown-value" id="hour">
            {hours}
          </div>
          <div className="countdown-label">Hours</div>
        </div>

        <div className="countdown-block">
          <div className="countdown-value" id="minute">
            {minutes}
          </div>
          <div className="countdown-label">Minutes</div>
        </div>

        <div className="countdown-block">
          <div className="countdown-value" id="second">
            {seconds}
          </div>
          <div className="countdown-label">Seconds</div>
        </div>
      </div>
    </div>
  )
}
